<template>
  <div class="success-stories-area bg pt-100 pb-75">
    <div class="container">
      <div class="d-sm-flex justify-content-between align-items-center mb-50">
        <div
          class="section-title left-title mb-0 mw-648"
          data-aos="fade-up"
          data-aos-duration="1200"
          data-aos-delay="100"
        >
          <img title="celebrity marketing agency India, influencer marketing company, ad shoots agency, TV commercial production, digital marketing services, brand endorsements India, social media marketing for brands, Instagram verification services, events and inaugurations management, MyCelebrity by Digitalentio, Bangalore branding agency, celebrity endorsement agency, verified badge services Instagram Facebook, PR article services India, media coverage agency, top branding agency in Bangalore" 
            class="object mb-4"
            src="../../assets/logos/Main/Myceleblogo.png"
            alt="MyCelebrity Logo"
            style="max-height: 50px;"
          />
          <span class="top-title">Our Recent Works</span>
          <h2 title="celebrity marketing agency India, influencer marketing company, ad shoots agency, TV commercial production, digital marketing services, brand endorsements India, social media marketing for brands, Instagram verification services, events and inaugurations management, MyCelebrity by Digitalentio, Bangalore branding agency, celebrity endorsement agency, verified badge services Instagram Facebook, PR article services India, media coverage agency, top branding agency in Bangalore" >
            MyCelebrity is a celebrity and influencer agency that specialized in elevating brands through impactful collaborations.
          </h2>
        </div>
        <router-link
          to="/success-stories"
          class="read-more mt-3 d-inline-block"
          data-aos="fade-up"
          data-aos-duration="1200"
          data-aos-delay="200"
        >
          VIEW MORE
          <img title="celebrity marketing agency India, influencer marketing company, ad shoots agency, TV commercial production, digital marketing services, brand endorsements India, social media marketing for brands, Instagram verification services, events and inaugurations management, MyCelebrity by Digitalentio, Bangalore branding agency, celebrity endorsement agency, verified badge services Instagram Facebook, PR article services India, media coverage agency, top branding agency in Bangalore"  
          src="../../assets/images/icon-right-red.png" alt="icon-right-red" />
        </router-link>
      </div>

      <div
        class="row align-items-center"
        data-aos="fade-up"
        data-aos-duration="1200"
        data-aos-delay="300"
      >
        <div
          class="col-lg-3 col-sm-6"
          v-for="post in instagramPosts"
          :key="post.id"
        >
          <div class="success-single-item style-two transition-y">
            <!-- Instagram Embed -->
            <iframe
              :src="`https://www.instagram.com/p/${post.code}/embed`"
              width="100%"
              height="480"
              frameborder="0"
              allowfullscreen
              scrolling="no"
              allowtransparency="true"
              class="instagram-frame"
            ></iframe>
            <div class="success-content d-flex align-items-center justify-content-between">
              <div>
                
              </div>
           <!--  <div class="icon">
                <img
                  src="../../assets/images/icon-up-right-arrow.png"
                  alt="icon-up-right-arrow"
                /> 
              </div>-->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "SuccessStories",
  data() {
    return {
      instagramPosts: [
        {
          id: 1,
          code: "CqFrwpPoYDV", // Instagram post code (from URL like instagram.com/p/C5VdPfcs1TP/)
        },
        {
          id: 2,
          code: "DEHG-wCPsX2",

        },
        {
          id: 3,
          code: "DFpSO-QPQJR", 

        },
        {
          id: 4,
          code: "DFpR8AwPG4M", 
 
        },
        {
          id: 5,
          code: "DEHJCq-v9JT",

        },
        {
          id: 6,
          code: "DIGKuOmPr-Q",

        },
        {
          id: 7,
          code: "DHFjgJAPCxI",

        },
        {
          id: 8,
          code: "C6YPRt-PrTW",
   
        },
       

      ],
    };
  },
});
</script>

<style lang="scss" scoped>
.success-stories-area.bg {
  background: linear-gradient(
    180deg,
    #fff 0%,
    rgba(255, 150, 150, 0.27) 0%,
    rgba(255, 255, 255, 0) 100%
  );
}

.success-single-item {
  position: relative;
  margin-bottom: 30px;

  .instagram-frame {
    border-radius: 20px;
    margin-bottom: 20px;
  }

  .success-content {
    margin-top: 15px;
    h3 {
      font-size: 22px;
      color: var(--headingColor);
    }
    span {
      color: var(--bodyColor);
    }
    .icon {
      width: 50px;
      height: 50px;
      line-height: 50px;
      text-align: center;
      border-radius: 50px;
      background-color: #232323;
      transition: var(--transition);
    }
  }
}

.success-content {
  margin-left: 106px;

  .object {
    margin-bottom: 70px;
  }

  h2 {
    font-size: 36px;
    margin-bottom: 60px;
  }
}

@media only screen and (max-width: 767px) {
  .success-content {
    margin-left: 0;

    .object {
      margin-bottom: 20px;
    }

    h2 {
      font-size: 25px;
      margin-bottom: 20px;
    }
  }

  .success-single-item .success-content {
    h3 {
      font-size: 20px;
    }

    span {
      font-size: 15px;
    }
  }
}

@media only screen and (min-width: 768px) and (max-width: 991px),
       only screen and (min-width: 992px) and (max-width: 1199px) {
  .success-content {
    margin-left: 0;
  }
}
</style>
